import { render } from "./NewOrgInvoice.vue?vue&type=template&id=3be4b2d2"
import script from "./NewOrgInvoice.vue?vue&type=script&lang=js"
export * from "./NewOrgInvoice.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "@/locales/views/agro_exporter/finances/container_outcomes/new_org_invoice.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Falejo%2FDevelopment%2FAT%2FApps%2Fagrotecchain_vue%2Fsrc%2Fviews%2Fagro_exporter%2Ffinances%2Fcontainer_outcomes%2FNewOrgInvoice.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locales/models/org_invoice.yml?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fhome%2Falejo%2FDevelopment%2FAT%2FApps%2Fagrotecchain_vue%2Fsrc%2Fviews%2Fagro_exporter%2Ffinances%2Fcontainer_outcomes%2FNewOrgInvoice.vue&lang=yaml"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/home/alejo/Development/AT/Apps/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__